<template>
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-3 col-sm-3 col-md-push-9" :style="setMapHeight">
        <div class="row dealer_header">
          <p>Dealer Locator</p>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group input-group">
              <label
                for
              >Enter your Zip Code or Address in the field, or drag
                  <img src='../assets/Star.svg' style="display: inline-block; margin-left: auto; margin-right: auto; width: 10%;" />
                  to the desired location.</label>
              <GmapAutocomplete
                @place_changed="setPlace"
                :value="address"
                @keyup.enter="trigger"
                id="address"
                class="form-control"
                placeholder="Address"
              />
              <!-- <input type="text" @keyup.enter="trigger" id="address" class="form-control" placeholder="Address" v-model="address"> -->
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-sm-12 col-xs-12">
            <!-- Extra button to make sure the dealers were getting mapped -->
            <!-- <div>
                            <button class="col-md-12 col-sm-12 col-xs-12 btn btn-success" v-on:click="getDealers" ref="searchDealer">Map Dealers</button>
            </div>-->
          </div>
          <div class="col-md-6 col-sm-12 col-xs-12">
            <div class="form-group input-group">
              <button
                class="col-md-12 col-sm-12 col-xs-12 btn btn-success"
                v-on:click="searchDealer"
                ref="searchDealer"
              >Find</button>
            </div>
          </div>
        </div>
        <div class="dealer_list" :style="setListHeight">
          <div
            class="dealer col-md-12"
            v-for="(marker, index) in markers"
            :key="index"
            :class="{active:marker.id == selected}"
            @click="setActive(marker.id)"
          >
            <div>
              <strong>
                <span class="dealer_id">{{marker.id + 1}}.</span>
                <span class="dealer_name">{{marker.info.name}}</span>
              </strong>
            </div>
            <div><span class="dealer_street">{{marker.info.street}}</span></div>
            <!-- <div><span class="dealer_address">{{dealer.city}}, {{dealer.state}} {{dealer.zip}} {{dealer.country}}</span></div>-->
            <div>
              <span class="dealer_address">{{marker.info.address}}</span>
            </div>
            <div>
              <span class="dealer_phone">{{marker.info.phone}}</span>
            </div>
            <div>
              <!-- <a v-bind:href="'http://' + marker.info.url" class="dealer_url">{{marker.info.url}}</a> -->
              <a v-bind:href="marker.info.url" class="dealer_url">{{marker.info.url}}</a>
            </div>
            <div><span class="dealer_distance">{{Number((marker.info.distance).toFixed(1))}} miles</span></div>
            <hr />
          </div>
        </div>
      </div>
      <div class="col-md-9 col-sm-9 col-md-pull-3">
        <div class="row">
          <h4 v-if="loading">Loading...</h4>
          <GmapMap :center="userLocation" :zoom="10" map-type-id="roadmap" :style="setMapHeight">
            <GmapMarker
              :position="userLocation"
              :clickable="false"
              :draggable="true"
              :animation="2"
              :zoom="100"
              @dragend="getUserPosition($event.latLng)"
              :icon="{ url: require('../assets/Star.svg'),
                                size: {width: 46, height: 46, f: 'px', b: 'px'},
                                scaledSize: {width: 46, height: 46, f: 'px', b: 'px'}
                            }"
            />
            <GmapMarker
              :key="index"
              v-for="(marker, index) in markers"
              :position="marker.latlng"
              :clickable="true"
              :draggable="false"
              :animation="2"
              @click="setActive(index)"
              :icon="{ url: require('../assets/' + (index+1) + '.svg'),
                                size: {width: 46, height: 46, f: 'px', b: 'px'},
                                scaledSize: {width: 46, height: 46, f: 'px', b: 'px'}
                            }"
            >
              <gmap-info-window
                :position="selectedMarker.latlng"
                v-if="selectedMarker"
                :opened="marker.info.state"
                @closeclick="marker.info.state=false"
              >
                <p>
                  <b>{{marker.info.name}}</b>
                </p>
                <p>{{marker.info.street}}</p>
                <p>{{marker.info.address}}</p>
                <p>{{marker.info.phone}}</p>
                <p>{{Number(marker.info.distance).toFixed(1)}} miles</p>
                <a v-bind:href="'http://' + marker.info.url" class="dealer_url">{{marker.info.url}}</a>
              </gmap-info-window>
            </GmapMarker>
          </GmapMap>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
// 2
// import { ALL_ITEM_SEARCH_QUERY } from '../constants/graphql'
import axios from 'axios'

export default {
  name: 'LinkList',
  data () {
    return {
      search_dealers_nearby: [],
      loading: 0,
      markers: [],
      userLocation: {
        lat: 43.6686454,
        lng: -116.6462445
      },
      address: '',
      selectedMarker: null,
      selected: 0,
      infoWindowOpen: false,
      windowHeight: 900,
      firstLoad: true
    }
  },
  // apollo: {
  //   search_dealers_nearby: {
  //     variables () {
  //       if (!this.$store.state.actionsCompleted) {
  //         this.getDealers(this.userLocation, '')
  //       }

  //       return {
  //         latitude: this.userLocation.lat,
  //         longitude: this.userLocation.lng
  //       }
  //     },
  //     skip () {
  //       return !this.userLocation.lat
  //     }
  //   }
  // },
  watch: {
    // windows onresize function
    windowHeight (newHeight, oldHeight) {
      this.windowHeight = newHeight
    },
    // search user's position and dealer list
    search_dealers_nearby (dealers_nearby) {
      if (this.firstLoad) {
        this.getLocation()
        this.firstLoad = false
      }
    }
  },
  mounted () {
    // this.getLocation();
    this.getLocation()
    this.getDealers(this.userLocation)
    this.windowHeight = window.innerHeight
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowHeight = window.innerHeight
      })
    })
  },
  methods: {
    // point out 10 dealers' location on map
    setMarkers () {
      // If to make sure there is at least one dealer in the list
      if (this.search_dealers_nearby !== [] && typeof (this.search_dealers_nearby) !== 'undefined') {
        var markerList = []
        this.search_dealers_nearby.forEach(function (item) {
          // If to make sure latitude and longitude are set and not 0 (b/c that's in the water)
          if (item.partner_latitude != null && item.partner_longitude != null && item.partner_latitude !== 0 && item.partner_longitude !== 0 && markerList.length < 10) {
            if (item.display_name) {
              item.display_name = item.display_name.split(":0 ").pop();
            }
            markerList.push(
              {
                id: -1,
                latlng: {
                  lat: item.partner_latitude,
                  lng: item.partner_longitude
                },
                info: {
                  name: item.display_name,
                  street: item.street,
                  address: item.contact_address,
                  phone: item.phone_sanitized,
                  url: item.url,
                  state: false,
                  distance: item.distance
                }
              }
            )
          } else if (item.partner_latitude === 0 && item.partner_longitude === 0) {
            console.log(item.display_name)
          }
        })
        this.markers = markerList
        this.selectedMarker = markerList[0]
        this.markers[0].info.state = true

        for (var i = 0; i < markerList.length; i++) {
          this.search_dealers_nearby[i].id = i
          this.markers[i].id = i
        }
      }
    },
    // get user's location on map
    getLocation () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition)
      } else {
        console.log('Geolocation is not supported by this browser.')
      }
    },
    // show user's location and search dealerList
    showPosition (position) {
      this.userLocation.lat = position.coords.latitude
      this.userLocation.lng = position.coords.longitude
      this.getDealers(this.userLocation)
      var vm = this
      setTimeout(function () {
        vm.setMarkers()
      }, 2000)
    },
    // convert address to coord and search the nearest dealerList
    searchDealer () {
      var vm = this
      const proxy_url = 'https://cors-anywhere.herokuapp.com/'
      axios
        .get(
          // `${proxy_url}https://maps.googleapis.com/maps/api/geocode/json`,
          `https://maps.googleapis.com/maps/api/geocode/json`,
          {
            headers: {
              'Content-Type': 'application/json;charset=UTF-8',
            },
            params: {
              address: this.address,
              key: process.env.GOOGLE_MAP_KEY
            }
          }
        )
        .then(response => {
          vm.userLocation.lat = response.data.results[0].geometry.location.lat
          vm.userLocation.lng = response.data.results[0].geometry.location.lng
          setTimeout(function () { vm.getDealers(vm.userLocation) }, 2000)
          vm.selected = 0
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    // active selected dealer on click over marker and list
    setActive (id) {
      if (id > this.markers.length) {
        return
      }
      this.selected = id
      this.markers.forEach(function (marker) {
        marker.info.state = false
      })
      this.markers[id].info.state = true
    },
    // press 'enter' key trigger searchDealer function
    trigger () {
      this.$refs.searchDealer.click()
    },
    // refresh the dealer list after user location marker drag
    getUserPosition (marker) {
      var vm = this
      vm.userLocation.lat = marker.lat()
      vm.userLocation.lng = marker.lng()
      vm.getDealers(vm.userLocation)
      setTimeout(function () { vm.setMarkers() }, 2000)
    },
    // google autocomplete
    setPlace (place) {
      this.address = place.formatted_address
    },
    // method for retieving all dealers
    getDealers (userLocation) {
      this.$store.dispatch('updateDealers', userLocation).then(() => {
        this.$store.dispatch('updateDealers', userLocation).then(() => {
          if (this.$store.state.actionsCompleted) {
            this.setDealers(this.$store.state.dealers)
            this.$store.state.actionsCompleted = false
          }
        })
      })

      if (this.$store.state.actionsCompleted) {
        this.setDealers(this.$store.state.dealers)
        this.$store.state.actionsCompleted = false
      }
    },
    setDealers (dealers) {
      // Calculate the distance from the user to the dealer for each dealer
      dealers.forEach(dealer => {
        let address_info = dealer.contact_address_complete.split(',')

        // set dealers street
        var street = address_info[0].split(' ')
        dealer.street = `${street[0]} ${street[1].charAt(0).toUpperCase()}${street[1].slice(1).toLowerCase()} ${street[2]}`

        // get address attributes
        var zip = address_info[1].split(' ')[0].split('-')[0]
        var county = address_info[1].split(' ')[1]
        var state = dealer.state
        var country = address_info[2]

        // Set dealers address
        dealer.contact_address = `${county.charAt(0).toUpperCase()}${county.slice(1).toLowerCase()}, ${state} ${zip}, ${country}`
      })
      this.search_dealers_nearby = dealers
      this.search_dealers_nearby.sort((a, b) => (a.distance > b.distance) ? 1 : -1)
      this.setMarkers()
    }
  },
  computed: {
    // set height dynamically
    setMapHeight () {
      return `height: ${this.windowHeight}px`
    },
    setListHeight () {
      return `height: ${this.windowHeight - 202}px`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LinkList.vue